import { Link } from 'react-router-dom';
import CategoryCard from '@/components/base/CategoryCard';
import { categories } from '@/mocks/site';

export default function FeaturedCategories() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            探索兴趣分类
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            八大兴趣领域，总有一个属于你的天地。点击进入，发现同好，分享热爱。
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {categories.map((cat) => (
            <CategoryCard
              key={cat.slug}
              slug={cat.slug}
              name={cat.name}
              icon={cat.icon}
              description={cat.description}
              articleCount={cat.articleCount}
              color={cat.color}
              imageUrl={cat.imageUrl}
            />
          ))}
        </div>
        <div className="text-center mt-10">
          <Link
            to="/categories"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部分类 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}